module.exports = __webpack_public_path__ + "img/36.dbde0d4.jpg";